import { Link } from 'react-router-dom';
import { featureBenefits } from '@/mocks/categories';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-primary-500 tracking-widest uppercase mb-3">
            Why Data-Driven Shopping Wins
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Smarter Decisions
            <br />
            Through Structured Data
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            The PandabuySpreadsheet system gives you all the tools you need to compare, evaluate,
            and choose products with confidence.
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12">
          {featureBenefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/60 hover:border-accent-200 transition-all duration-300 group"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${benefit.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="text-center bg-accent-100/50 rounded-2xl py-10 px-6">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Start Using PandabuySpreadsheet Today
          </h3>
          <p className="text-foreground-600 text-sm md:text-base mb-6 max-w-lg mx-auto">
            Compare smarter, not harder. Access structured product data across 15 categories now.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
            <Link
              to="/blog/pandabuy-spreadsheet-comparison-guide"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-50 text-foreground-700 font-semibold text-sm border border-background-200 hover:border-foreground-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Comparison Guide
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}